enum IntegrationEditStep {
  CHOOSE,
  MAP,
  FREQUENCY,
  FINISH,
}

export default IntegrationEditStep;
